import * as React from "react";
import { Link, styled } from "@mui/material";
import { CitationData } from "./types";
import { ReactComponent as OpenInNewIcon } from "fe-web-components/assets/openInNewIcon.svg";

//region [[ Styles ]]

const ReferenceView = styled("div")(({ theme }) => ({
  borderRadius: 4,
  border: "1px solid transparent",
  "& .citationTitle": {
    marginBottom: 4,
    fontWeight: 600,
  },
  "& .citationLink": {
    display: "inline-block",
    margin: "0 0 2px 5px",
    verticalAlign: "middle",
    color: theme.palette.primary.main,
    "& svg": {
      width: 12,
      height: 12,
    },
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ReferenceProps {
  citationData: CitationData;
  style?: React.CSSProperties;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const Reference = ({ citationData, style }: ReferenceProps) => {
  return (
    citationData && (
      <ReferenceView style={style}>
        <div className={"citationTitle"}>{citationData.title}</div>
        <span>
          {citationData.vancouver || citationData.source}
          {citationData.url && (
            <Link
              href={citationData.url}
              target="_blank"
              className={"citationLink"}
            >
              <OpenInNewIcon />
            </Link>
          )}
        </span>
      </ReferenceView>
    )
  );
};
